import {LocationDetailsResponse} from 'src/app/shared/models/LocationDetailsResponse.model';
import {DestinationBankAccountCreateDto} from './recipient-bank-account-create-dto.model';

export class RecipientCreateDto {
  public firstName: string;
  public lastName: string;
  public bankAccount: DestinationBankAccountCreateDto;
  public tags: string[];
  public location: LocationDetailsResponse;
  public memo: string;
}
